module.exports = __webpack_public_path__ + "static/media/video1.6a489043.mp4";